import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from "@angular/core";
import {NgIcon, provideIcons} from "@ng-icons/core";
import {bootstrapHeart} from "@ng-icons/bootstrap-icons";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-main-donate-button-short',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIcon
  ],
  providers: [
    provideIcons({
      bootstrapHeart
    })
  ],
  template: `
    <a
      [class.dbox-donation-button]="useDonorBox()"
      class="w-full h-[64px] px-[18px] justify-center items-center gap-[7px] inline-flex primary-button"
      [id]="aId()"
      [hreflang]="hreflang()"
      [target]="target()"
      [href]="href()">
      <ng-icon class="text-[#FEC639]" name="bootstrapHeart" size="1.375em"/>
      <div
        class="text-center text-[#f7f8f7] font-medium leading-loose" i18n>
        DONATE
      </div>
    </a>
  `,
  host: {
    class: ''
  }
})
export class MainDonateButtonComponentShort implements AfterViewInit {

  public readonly eventParams = input.required<{
    trackEvent: string;
    section: string;
  }>();

  public readonly href = input<string>('https://donorbox.org/quick-donation-c4u?designation=Upgrade%20donated%20cars&amp;default_interval=o');
  public readonly target = input<'_blank' | '_self'>('_blank');
  public readonly aId = input<string>('preview_inline_popup_button');
  public readonly hreflang = input<string>('en');
  public readonly useDonorBox = input<boolean>(true);

  private readonly platformId = inject(PLATFORM_ID);
  public ngAfterViewInit(): void {
    if (this.useDonorBox()) {
      if (isPlatformBrowser(this.platformId)) {
        if ('dw_open' in window && typeof window.dw_open === 'function') {
          window.dw_open();
        }
      }
    }
  }
}
